/* eslint-disable import/no-anonymous-default-export */
import client from "./Client";

const getStudents = (page = 0, rows = 50, search = "", type = "", filter_value = "") => {
  const params = {};
  if (page) {
    params.page = page;
  }
  if (rows) {
    params.rows = rows;
  }
  if (search) {
    params.search = search;
  }
  if (type) {
    params.type = type;
  }
  if (filter_value) {
    params.filter_value = filter_value;
  }

  return client.get(`/staff/students`, {
    params,
  });
};

const getStudentsInClass = (page, rows, search, class_id, type) => {
  const params = {};
  if (page >= 0) {
    params.page = page;
  }
  if (rows >= 0) {
    params.rows = rows;
  }
  if (search) {
    params.search = search;
  }
  if (type) {
    params.type = type;
  }
  return client.get(`/staff/class/${class_id}/students`, {
    params,
  });
};

const getSingleStudent = (studentId, schoolId) =>
  client.get(`/staff/school/${schoolId}/student/${studentId}`);

const getStudentProfile = (studentId, schoolId) =>
  client.get(`/staff/school/${schoolId}/student/${studentId}/profile`);

const getStudentPercentage = (studentId, schoolId) =>
  client.get(
    `/staff/school/${schoolId}/stat/student/${studentId}/assessment/percentage`
  );

export default {
  getStudents,
  getSingleStudent,
  getStudentsInClass,
  getStudentProfile,
  getStudentPercentage,
};
